// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"5e860adc","665":"5e860adc","726":"5e860adc","734":"5e860adc","751":"5e860adc","832":"5e860adc","886":"92bce0fb","977":"5e860adc"}[chunkId] + ".chunk.css";
};